import { Location } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { OrderShipment_Status as OrderShipmentStatus } from "gen/txn/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

import { cleanStatus } from "./cleanStatus"

const statusSegments: Record<OrderShipmentStatus, string> = {
  [OrderShipmentStatus.UNDEFINED]: "",
  [OrderShipmentStatus.RECEIVED]: "received",
  [OrderShipmentStatus.VOUCHERED]: "vouchered",
  [OrderShipmentStatus.PAID]: "paid",
}

export function orderShipments(
  status: OrderShipmentStatus,
  location?: Pick<Location, "id" | "name">
): WebUrl {
  const pathname = `/pos/purchase-orders/${statusSegments[status]}`

  if (!location) {
    return { pathname }
  }

  const query: QueryParams = {
    locations: encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    ),
  }

  return { pathname, query }
}

export function orderShipment(
  id?: PBUUID,
  status?: OrderShipmentStatus
): WebUrl {
  const pathname = `/pos/purchase-orders/${UUID.idString(id)}`
  const statusParam = orderShipmentStatusParam(status)

  if (!statusParam) {
    return { pathname }
  }

  return {
    pathname,
    query: { status: statusParam },
  }
}

export function orderShipmentStatusParam(
  status = OrderShipmentStatus.RECEIVED
): string {
  return cleanStatus(OrderShipmentStatus[status])
}
